import { render, staticRenderFns } from "./TimeStats.vue?vue&type=template&id=20466d7c&scoped=true"
import script from "./TimeStats.vue?vue&type=script&lang=js"
export * from "./TimeStats.vue?vue&type=script&lang=js"
import style0 from "./TimeStats.vue?vue&type=style&index=0&id=20466d7c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20466d7c",
  null
  
)

export default component.exports